import Box from '@mui/material/Box';
import { Form } from 'react-admin';
import CheckboxToShowBox from '@/components/common/forms/common/checkbox-to-show-box/checkbox-to-show-box';
import TextInputWithLabels from '@/components/common/forms/common/text-input-with-labels/text-input-with-labels';
import ImageInputWithLabelOnTop from '@/components/common/forms/common/image-input-with-label-on-top/image-input-with-label-on-top';

const formId = '_form_maintenance_curative_epaufrures_1';

interface Props {
    readOnly?: boolean;
    defaultValues?: (formId: string) => {};
}

const SpallsForm = ({ readOnly = false, defaultValues = (_formId: string): any => {} }: Props) => (
    <Form defaultValues={defaultValues(formId)}>
        <Box
            sx={{
                display: 'grid',
                gap: 2,
            }}
        >
            <CheckboxToShowBox label={'Joints'} keysToRemoveFromFormValues={['JointML', 'JointU']} readOnly={readOnly}>
                <TextInputWithLabels rightLabel={'ML'} source='JointML' readOnly={readOnly} />
                <TextInputWithLabels rightLabel={'U'} source='JointU' readOnly={readOnly} />
            </CheckboxToShowBox>

            <CheckboxToShowBox label={'Seuil'} keysToRemoveFromFormValues={['SeuilM2']} readOnly={readOnly}>
                <TextInputWithLabels rightLabel={'m²'} source='SeuilM2' readOnly={readOnly} />
            </CheckboxToShowBox>

            <CheckboxToShowBox label={'Nez de quai'} keysToRemoveFromFormValues={['NezDeQuaiML']} readOnly={readOnly}>
                <TextInputWithLabels rightLabel={'ML'} source='NezDeQuaiML' readOnly={readOnly} />
            </CheckboxToShowBox>

            <CheckboxToShowBox
                label={'Joints de construction'}
                keysToRemoveFromFormValues={['JointsDeConstructionML']}
                readOnly={readOnly}
            >
                <TextInputWithLabels rightLabel={'ML'} source='JointsDeConstructionML' readOnly={readOnly} />
            </CheckboxToShowBox>

            <ImageInputWithLabelOnTop label='Joindre des photos (.png, .jpg)' source='media' readOnly={readOnly} />

            <TextInputWithLabels topLabel={'Précision sur la localisation'} source='Localisation' readOnly={readOnly} />
        </Box>
    </Form>
);

export default SpallsForm;
